import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=bea2e27e&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=bea2e27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2e27e",
  null
  
)

export default component.exports